import React from 'react'
import { Chip } from '@mui/material';
import styled from 'styled-components';
import BASE_API_URL from '../../../apis/index';
import { Link } from 'react-router-dom';

function UserCompShortDetails({ company }) {
    return (
        <div className="border mb-3 p-4 rounded-4 position-relative">
            <StatusPill status={company.status}>{company.status}</StatusPill>
            <div className="d-flex justify-content-between align-items-center">
                <div className='d-flex'>
                    <CompLogo>
                        <img src={`${BASE_API_URL}/uploads/user_comp_docs/${company.company_logo}`} alt="Company Logo" />
                    </CompLogo>
                    <div className='ms-3'>
                        <h4 className="txt_color_primary d-inline"> {company.company_name} </h4>
                        <div className='my-2'>
                            {JSON.parse(company.company_types).map((type) => (
                                <Chip
                                    key={type}
                                    label={type}
                                    color="warning"
                                    variant="outlined"
                                    sx={{ mr: 1 }}
                                    className="rounded"
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <Link to={`/admin/company-details?compId=${company.id}`}>
                    <button className='btn btn-outline-warning bg_secodary_color'> View full details </button>
                </Link>
            </div>
        </div>
    )
}

export default UserCompShortDetails;

const StatusPill = styled.span`
  padding: 8px 12px;
  position: absolute;
  top: 0;
  right: 20px;
  border-radius: 0 0 8px 8px;
  font-weight: 400;
  font-size: 12px;
  display: inline-block;
  min-width: 100px;
  text-align: center; 

  ${({ status }) =>
        status === "Approved" &&
        `
      background: #d4f6d4;
      color: #0a8a0a;
    `}

  ${({ status }) =>
        status === "Pending" &&
        `
      background: #fff3cd;
      color: #c77d00;
    `}

  ${({ status }) =>
        status === "Rejected" &&
        `
      background: #ffe1e1;
      color: #d10000;
    `}
`;

const CompLogo = styled.div`
  img {
    width: 75px;
    height: 75px;
    object-fit: contain;
  }
`;